import { makeStyles } from "@material-ui/core";

export const thresholdConfigStyles = makeStyles((theme) => ({
    triggerButton: {
        height: 56,
        width: 56,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.primary.main,
    },
    title: {
        color: theme.palette.text.primary,
        fontSize: 20,
        fontWeight: 500,
        marginBottom: theme.spacing(2),
    },
    table: {
        width: '100%',
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(1),
        borderBottom: `2px solid ${theme.palette.divider}`,
    },
    tableRow: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 0),
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    statusCell: {
        flex: 1,
        color: theme.palette.text.primary,
    },
    headerStatusCell: {
        flex: 1,
        fontWeight: 600,
        color: theme.palette.text.secondary,
    },
    daysCell: {
        width: 140,
    },
    readonlyInputWrapper: {
        width: '100%',
    },
    headerDaysCell: {
        width: 140,
        fontWeight: 600,
        color: theme.palette.text.secondary,
    },
    legend: {
        marginTop: theme.spacing(3),
    },
    legendTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    legendRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 0),
    },
    legendIcon: {
        fontSize: 16,
    },
    legendIconWithin: {
        fill: theme.palette.success.main,
    },
    legendIconApproaching: {
        fill: theme.palette.warning.main,
    },
    legendIconBreached: {
        fill: theme.palette.error.main,
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(3),
    },
    emptyState: {
        padding: theme.spacing(2, 0),
        color: theme.palette.text.secondary,
    },
}));
